// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DPrw","buttons":"styles_buttons__1piMm"};